import { CURRENT_SCHEMA_VERSION } from './constants.js';
import type { PhotobookProject } from './schemas.js';
import { photobookProjectSchema } from './schemas.js';

export type Migration = {
  from: number;
  to: number;
  migrate: (project: PhotobookProject) => PhotobookProject;
};

const migrations: Migration[] = [
  // Future migrations go here, e.g. 1 → 2
];

export function migrateProject(input: unknown): PhotobookProject {
  let current = input as PhotobookProject;
  if (!current || typeof current !== 'object') {
    throw new Error('Ongeldig project: geen object.');
  }

  let version = (current as { schemaVersion?: number }).schemaVersion ?? 0;
  if (version > CURRENT_SCHEMA_VERSION) {
    throw new Error(
      `Dit project gebruikt schemaversie ${version}, die nieuwer is dan ondersteunde versie ${CURRENT_SCHEMA_VERSION}.`,
    );
  }

  while (version < CURRENT_SCHEMA_VERSION) {
    const migration = migrations.find((m) => m.from === version);
    if (!migration) {
      throw new Error(`Geen migratie beschikbaar van schemaversie ${version}.`);
    }
    current = migration.migrate(current);
    version = migration.to;
    current.schemaVersion = version;
  }

  return photobookProjectSchema.parse(current);
}

export function safeParseProject(input: unknown):
  | {
      success: true;
      data: PhotobookProject;
    }
  | {
      success: false;
      error: string;
    } {
  try {
    return { success: true, data: migrateProject(input) };
  } catch (err) {
    return {
      success: false,
      error: err instanceof Error ? err.message : 'Onbekende parsefout',
    };
  }
}
